import React, { useEffect, useState } from "react";
import { RootState } from "../../../../redux/rootReducers";
import { resetSession } from "../../../../redux/auth";
import { connect } from "react-redux";
import {
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
} from "../../../../redux/masterData";
import {
  addAutoUniqueNumberGenerationAction,
  getAutoUniqueNumberGenerationAction,
  resetAutoUniqueNumberGenerationData,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetMessage,
} from "../../../../redux/clientSettings";

import { ErrorSuccessModal, Loader, ToggleSwitch } from "../../../commons";
import { useParams } from "react-router-dom";

import toast, { Toaster } from "react-hot-toast";
import {
  AddAutoUniqueNumberPayloadType,
  GetAutoUniqueNumberPayloadType,
} from "../../../../commonTypes/clientSettingsTypes";
import "../style.scss"

type AppProps = {
  history: any;
  token: string | null;
  masterFetching: boolean;
  masterStatusCode: null | number;
  masterError: null | string;
  masterSuccess: null | number;
  masterMessage: string | null;
  menuName: string;
  success: null | number;
  fetching: boolean;
  error: null | string;
  statusCode: null | number;
  message: string | null;
  dispatchResetSession: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetClientSettingMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchAddMiscellaneousSettingsAction: (
    data: AddAutoUniqueNumberPayloadType
  ) => void;
  dispatchGetMiscellaneousSettingsAction: (
    data: GetAutoUniqueNumberPayloadType
  ) => void;
  autoUniqueNumberGenerationData: any;
  dispatchResetMiscellaneousSettingsData: () => void;
};

const MiscellaneousSetting = ({
  history,
  token,
  masterFetching,
  masterStatusCode,
  masterError,
  masterSuccess,
  masterMessage,
  success,
  fetching,
  error,
  statusCode,
  message,
  menuName,
  dispatchResetSession,
  dispatchResetMasterSuccess,
  dispatchResetMasterError,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingMessage,
  dispatchResetClientSettingsError,
  dispatchAddMiscellaneousSettingsAction,
  dispatchGetMiscellaneousSettingsAction,
  autoUniqueNumberGenerationData,
  dispatchResetMiscellaneousSettingsData,
}: AppProps) => {
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const [batchColumnInManufacturingJournal, setBatchColumnInManufacturingJournal] =
    useState<boolean>(false);
  const { id }: any = useParams();

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetClientSettingMessage();
    dispatchResetMasterMessage();
    dispatchResetMasterStatusCode();
    dispatchResetClientSettingsSuccess();
    dispatchResetClientSettingsError();
    dispatchResetMiscellaneousSettingsData();
    toast.dismiss();
    if (token) {
      let finalData = {
        token,
        clientCode: id,
        general_settings_type: "manufacturing_batch_details",
      };
      dispatchGetMiscellaneousSettingsAction(finalData);
    }
    return () => {
      toast.dismiss();
    };
  }, []);


  useEffect(() => {
    if (
      autoUniqueNumberGenerationData &&
      Object.keys(autoUniqueNumberGenerationData)?.length > 0
    ) {
      setBatchColumnInManufacturingJournal(
        autoUniqueNumberGenerationData?.is_enable === 1
      );
    } else {
      setBatchColumnInManufacturingJournal(false);
    }
  }, [autoUniqueNumberGenerationData]);

  useEffect(() => {
    if (
      success === 1 &&
      message?.includes("General Settings has been updated successfully")
    ) {
      toast.success("Miscellaneous Setting updated successfully!", {
        duration: 3000,
      });
      dispatchResetClientSettingMessage();
      dispatchResetClientSettingsSuccess();

    }

  }, [success, message, batchColumnInManufacturingJournal]);


  const handleChangeInToggle = () => {
    setBatchColumnInManufacturingJournal(!batchColumnInManufacturingJournal);
    let finalData = {
      token,
      clientCode: id,
      isAutoUniqueNumberCheck: !batchColumnInManufacturingJournal == true ? 1 : 0,
      general_settings_type: "manufacturing_batch_details",
    };

    dispatchAddMiscellaneousSettingsAction(finalData);
    dispatchResetClientSettingMessage();
    dispatchResetClientSettingsSuccess();
  };

  const handleErrorModal = () => {
    if (success === 0 || masterSuccess === 0) {
      dispatchResetMasterSuccess();
      if (statusCode === 401 || masterStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!masterError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode || masterStatusCode}
          />
        );
      } else if (
        (!!error || !!masterError) &&
        (statusCode !== 401 || masterStatusCode !== 401)
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!masterError}
            title="Error"
            message={error || masterError}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
              dispatchResetMasterSuccess();
              dispatchResetMasterError();
              dispatchResetMasterMessage();
              dispatchResetMasterStatusCode();
              dispatchResetClientSettingsSuccess();
              dispatchResetClientSettingsError();
              setBatchColumnInManufacturingJournal(true)
            }}
          />
        );
      }
    }
    return false;
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div style={{ maxWidth: "78%" }}>
          <p className="pdf_template_header">{menuName}</p>
          <p className="sub_heading">
            Configure additional invoice preferences and display options.
          </p>
        </div>
      </div>
      <div className="hsn-check-main-container mb-4 mt-4">
        <label htmlFor="Stage" className="royaltyLabel ms-3">
          Turn on to include Batch Column in the Manufacturing Journal:
        </label>
        <div className="questions-toggle ms-3">
          <div className="toggleFilterMainDiv">
            <div className="toggleFilterInnerDiv">
              <ToggleSwitch
                handleToggleChange={(e) => handleChangeInToggle()}
                isChecked={batchColumnInManufacturingJournal}
                name="dailyVoucherFilter"
              />

              <span className="mt-1 toogleTextLabel hsn-check-toggle-title">
                {batchColumnInManufacturingJournal ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <hr></hr>

      <div className="pdfImages mt-3">
        <Toaster />
        {fetching && <Loader />}
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  masterFetching: state.masterData.fetching,
  masterStatusCode: state.masterData.statusCode,
  masterError: state.masterData.error,
  masterSuccess: state.masterData.success,
  masterMessage: state.masterData.message,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  message: state.clientSettings.message,
  autoUniqueNumberGenerationData: state.clientSettings.autoUniqueNumberGenerationData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchAddMiscellaneousSettingsAction: (data: AddAutoUniqueNumberPayloadType) =>
    dispatch(addAutoUniqueNumberGenerationAction(data)),
  dispatchGetMiscellaneousSettingsAction: (
    data: GetAutoUniqueNumberPayloadType
  ) => dispatch(getAutoUniqueNumberGenerationAction(data)),
  dispatchResetMiscellaneousSettingsData: () =>
    dispatch(resetAutoUniqueNumberGenerationData()),

});

export default connect(mapStateToProps, mapDispatchToProps)(MiscellaneousSetting);
